import moment from 'moment'

export const schema = [
  {
    name: 'date',
    title: 'Новая дата отгрузки',
    input: {
      type: 'string',
      format: 'date',
    },
    options: {
      isDisabledDatePrev: false,
    },
  },
  {
    name: 'reason_id',
    title: 'Причина переноса',
    input: {
      type: 'string',
      view: {
        name: 'select-from-enum',
      },
      options: {
        showSearch: true,
      },
    },
  },
  {
    name: 'comment',
    title: 'Комментарий',
    required: true,
    input: {
      type: 'string',

    },
    options: {
      type: "textarea",
      minRows: 3,
      maxRows: 6
    }
  },
  /*{
    name: 'send_mail_notification',
    input: {
      type: 'boolean',

    },
    options: {
      label: "Отправить уведомление на почту дилера",
    }
  },*/
]
